import { defaultIconProps, IconProps } from './IconProps';

export const IconStackFullSize: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M3 7H11M3 7L4.33333 5M3 7L4.33333 9M11 7L9.66667 5M11 7L9.66667 9M13 13V1M1 13V1"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconStackFullSize.defaultProps = defaultIconProps;
